// extracted by mini-css-extract-plugin
module.exports = {"inputRow":"SubmitButton_inputRow__2SK_n","inputElement":"SubmitButton_inputElement__1Gdnl","btnLabel":"SubmitButton_btnLabel__cLrdP"};